import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const detail = {
  title: '地祇咒',
  content: [
    '地祇地祇，<br />承天效法，',
    '厚德载物，<br />护佑众生，',
    '祭祀地祇，<br />保家安宁。'
  ],
  description: '地祇咒为祭祀地祇之要咒，诵读可保家安宁，宅舍平安。',
  usage: [
    '农历每月初二、十六为祭祀吉日',
    '动土前诵读可保平安',
    '家中有丧葬事宜时诵读',
    '配合祭祀仪式使用效果更佳'
  ]
};

const FuzouDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-green-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          <button
            onClick={() => navigate('/fuzou')}
            className="flex items-center text-emerald-800 mb-8 hover:text-emerald-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            返回符咒列表
          </button>

          <div className="bg-white rounded-2xl shadow-xl border-2 border-emerald-200 overflow-hidden">
            <div className="bg-gradient-to-r from-emerald-500 to-green-500 py-6 text-center">
              <h1 className="text-3xl font-bold text-white font-serif tracking-widest">
                {detail.title}
              </h1>
            </div>

            <div className="p-8">
              <p className="text-gray-600 mb-8 italic text-center">
                祭祀地祇，保家安宁
              </p>

              <div className="space-y-4 text-xl sm:text-2xl font-medium text-gray-800 leading-relaxed font-serif text-center mb-10">
                {detail.content.map((line, index) => (
                  <p key={index} dangerouslySetInnerHTML={{ __html: line }}></p>
                ))}
              </div>

              <div className="space-y-6">
                <div className="bg-emerald-50 rounded-xl p-6 border border-emerald-100">
                  <h3 className="text-lg font-bold text-emerald-900 mb-3">咒语说明</h3>
                  <p className="text-gray-700">{detail.description}</p>
                </div>

                <div className="bg-emerald-50 rounded-xl p-6 border border-emerald-100">
                  <h3 className="text-lg font-bold text-emerald-900 mb-3">使用方法</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    {detail.usage.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuzouDetail;
